'use client'

import {useEffect} from 'react'
import {ensurePostHogInitialized} from '../analytics'

export function PostHogProvider({children}: { children: React.ReactNode }) {
    useEffect(() => {
        let cancelled = false;

        const initScript = () => {
            if (cancelled) return;
            void ensurePostHogInitialized();
        };

        if (typeof window.requestIdleCallback==='function') {
            const idleId = window.requestIdleCallback(initScript, {timeout: 2000});
            return () => {
                cancelled = true;
                window.cancelIdleCallback(idleId);
            };
        } else {
            const timeoutId = setTimeout(initScript, 1000);
            return () => {
                cancelled = true;
                clearTimeout(timeoutId);
            };
        }

    }, [])

    return children
}
